<template>
  <div class="container-fluid">
    <!-- <TopBar /> -->
    <div>
      <h3>Restoring tool</h3>
      <div class="row">
        <RestoreLocations />
      </div>
      <div class="row">
        <RestoreDocumentsFromLocation />
      </div>
      <div class="row">
        <ReEnableLoopIdentified />
      </div>
      <div class="row">
        <RestoreUserCampaignCalendar />
      </div>
    </div>
  </div>
</template>

<script>
// import TopBar from "../TopBar.vue";
import RestoreLocations from "./RestoreLocations.vue";
import ReEnableLoopIdentified from "./ReEnableLoopIdentified.vue";
import RestoreDocumentsFromLocation from "./RestoreDocumentsFromLocation.vue";
import RestoreUserCampaignCalendar from "./RestoreUserCampaignCalendar.vue";

export default {
  components: {
    // TopBar,
    RestoreLocations,
    ReEnableLoopIdentified,
    RestoreDocumentsFromLocation,
    RestoreUserCampaignCalendar
  }
};
</script>
